module.exports = __webpack_public_path__ + "media/images/img_icon_03-91deeda71052ff0822c9413237f36e51.png";